<template>
  <div class="invoice-receipt-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <input-search placeholder="费用项" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @issueReceiptRow="showIssueReceiptDialog" @changePagination="changePagination" @changeSelection="changeSelection" :operationArr="operationArr" @invoiceRecordRow="toInvoiceRecordInfoPage"  />

    <el-dialog title='收据预览' :visible.sync="issueReceiptDialogVisible" width="800px">
      <div class="receipt-box">
        <div class="printing-box" id="printReceipt" ref="print">
          <div class="printing-info1"></div>
          <div class="printing-info2">
            <div class="printing-info2-1">{{ receiptYear }}</div>
            <div class="printing-info2-2">{{ receiptMonth }}</div>
            <div class="printing-info2-3">{{ receiptDate }}</div>
          </div>
          <div class="printing-info3">{{ issueReceiptData.payer }}</div>
          <div class="printing-info4">{{ issueReceiptData.depositItemName }}</div>
          <div class="printing-info5">{{ issueReceiptData.amountInWords }}</div>
          <div class="printing-info6">
            <div v-for="item in issueReceiptData.amountUnit" class="printing-info6-item">{{ item }}</div>
          </div>
          <div class="printing-info7">{{ issueReceiptData.issuer }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="issueReceiptDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="printReceipt">打 印</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/invoice'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {capitalAmount} from "../../../tool/tools";
  import * as Printjs from "print-js";
  import bus from "../../../utils/bus";

  export default {
    components: {
      ButtonCancel,
      ButtonConfirmNext,
      TableMain,
      InputSearch,
      Breadcrumb},
    name: 'invoice-receipt-manage',
    data () {
      return {
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '收据管理'
        }],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'depositItemName',
          label: '费用项',
        }, {
          prop: 'payer',
          label: '付款人'
        }, {
          prop: 'enterpriseName',
          label: '付款单位',
        }, {
          prop: 'money',
          label: '金额(元)',
        }, {
          prop: 'payTime',
          label: '收款时间',
        }],
        tableData: [],
        operationArr: ['modify', 'issueReceipt'],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        timeValue: [],
        requestData: {
          pageNum: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          searchKey: ''
        },
        selectionArr: [],

        receiptYear: '',
        receiptMonth: '',
        receiptDate: '',
        issueReceiptData: {},
        issueReceiptDialogVisible: false,
      }
    },
    created () {
      this.getCreatTime()
    },
    activated() {
      this.getPage()
    },
    mounted() {},
    methods: {
      toInvoiceRecordInfoPage (serialNo) {
        this.$router.push({
          path: `/invoice_info_current/${serialNo}`
        })
      },
      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.receiptYear = year
        this.receiptMonth = month
        this.receiptDate = date
        this.timeValue[0] = year + '-' + month + '-01'
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        if (this.timeValue.length > 0) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`
          reqData.endTime = `${this.timeValue[1]} 23:59:59`
        }
        this.$axios.post(api.getDepositBillPage, reqData)
          .then(res => {
            let list = res.data.data.list
            this.total = res.data.data.total
            list.map(v => {
              v.code = v.billNo
              if (v.invoiceStatus === 'SUCCESS') {
                v.invoiceStatusText = '开票成功'
              } else if (v.invoiceStatus === 'FAIL') {
                v.invoiceStatusText = '开票失败'
              } else if (v.invoiceStatus === 'PENDING') {
                v.invoiceStatusText = '开票中'
              } else if (v.invoiceStatus === 'INVALID') {
                v.invoiceStatusText = '已作废'
              }
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              }
              v.amountInWords = capitalAmount(v.money)
              v.amountUnit = `￥${parseInt(v.money  * 100)}`
            })
            this.tableData = list
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },

      changeWindowLeftPagination (data) {
        this.windowLeftPageNum = data[0]
        this.windowLeftPageSize = data[1]
        this.getPageApply()
      },

      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      deleteSelection () {
        if (this.selectionArr.length === 0) {
          nAlert('请先选择需要删除的发票')
          return false
        } else {
          this.$confirm('是否确认删除所选中的发票？', '提示')
            .then(() => {
              this.deleteLine(this.selectionArr)
            })
            .catch(() => {
              console.log('取消删除')
            })
        }
      },
      deleteLine (code) {
        this.$axios.post(api.deleteAgent, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },

      showIssueReceiptDialog (data) {
        this.issueReceiptData = data
        this.issueReceiptData.issuer = bus.global.accountName
        this.issueReceiptDialogVisible = true
      },

      printReceipt () {
        Printjs({
          printable: "printReceipt", //要打印内容的id
          type: "html",
          style: '@page{size:auto;margin: -0.5cm 4.5cm 0cm -2cm;}',
          targetStyles: ['*']
        })
        setTimeout(() => {
          this.issueReceiptDialogVisible = false
          this.$confirm('系统检测到您有预打印操作，是否已打印此收款记录的收据？此操作会更改记录状态，请谨慎操作。', "温馨提示", {
            type: "warning",
            closeOnClickModal: false
          })
            .then(() => {
              this.printDepositBillReceipt()
            })
            .catch(() => {});
        }, 200)
        // this.$print(this.$refs.print)
      },

      // 修改收据状态
      printDepositBillReceipt () {
        let issueReceiptData = this.issueReceiptData
        for (let i in issueReceiptData) {
          if (issueReceiptData[i] === '') {
            issueReceiptData[i] = null
          }
        }
        issueReceiptData.expenseItem = issueReceiptData.depositItemName
        this.$axios.post(api.printDepositBillReceipt, issueReceiptData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.getPage()
            }
          })
          .catch(errorHandler('操作失败'))
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .invoice-receipt-manage {
    .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
      /*width: 50%!important;*/
    }

    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }

    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
      width: 360px;
      padding-right: 60px;
      margin: 40px auto 0;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
    .receipt-box {
      width: 642.52px;
      height: 302.36px;
      margin: 0 auto;
      background: url("../../../assets/receipt.jpg") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .printing-box {
        width: 642.52px;
        height: 302.36px;
        color: #111111;
        position: relative;
        top: 0;
        left: 0;
        font-size: 12px;
        .printing-info1 {
          width: 80px;
          text-align: left;
          position: absolute;
          top: 60px;
          left: 140px;
        }
        .printing-info2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          top: 60px;
          right: 60px;
          .printing-info2-1 {
            width: 40px;
            margin-right: 10px;
          }
          .printing-info2-2 {
            width: 40px;
            margin-right: 10px;
          }
          .printing-info2-3 {
            width: 40px;
          }
        }
        .printing-info3 {
          text-align: left;
          width: 255px;
          height: 40px;
          position: absolute;
          top: 80px;
          left: 135px;
        }
        .printing-info4 {
          text-align: left;
          width: 130px;
          height: 40px;
          position: absolute;
          top: 80px;
          right: 40px;
        }
        .printing-info5 {
          text-align: left;
          width: 275px;
          height: 40px;
          line-height: 40px;
          position: absolute;
          top: 130px;
          left: 185px;
        }
        .printing-info6 {
          text-align: left;
          width: 140px;
          height: 36px;
          position: absolute;
          top: 144px;
          right: 36px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .printing-info6-item {
            width: 15.5px;
            height: 36px;
            line-height: 36px;
            font-size: 20px;
            text-align: center;
            font-style: italic;
            font-weight: bolder;
          }
        }
        .printing-info7 {
          text-align: left;
          width: 100px;
          height: 20px;
          position: absolute;
          bottom: 14px;
          right: 30px;
        }
      }
    }
  }

  .el-dialog__body {
    .el-table .cell{
      text-align: center;
    }
    .el-table th>.cell {
      color: #48576a;
      font-weight: bold;
    }
  }
  .el-dialog {
    .el-dialog .el-dialog__body .el-table__empty-block {
      margin: 0 auto;
    }
    .el-table__empty-text {
      width: auto;
    }
    .el-dialog__header {
      text-align: center
    }
    .el-dialog__body {
      .el-table th:first-child {
        width: auto!important;
      }
    }
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceReceiptManage/InvoiceReceiptManage.vue